import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useCertificateReminders = defineStore('certificate-reminders', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.certificateReminder_GetReminders,
    dto: 'CertificateReminderDto',
    create: api.certificateReminder_CreateReminder,
    update: api.certificateReminder_UpdateReminder,
    delete: api.certificateReminder_DeleteReminder,
    signalR: 'CertificateReminderUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
